/**
 * @ngdoc service
 * @name commons.service:aeroLineHttpInterceptor
 *
 * @description
 * Intercept every request adn modify request response data/headers
 */
(function () {
    'use strict';

    angular.module('aeroLineCrew').factory('aeroLineHttpInterceptor', [
        'ApplicationService',
        'EventManagerService',
        '$q',
        '$location',
        function (ApplicationService, EventManagerService, $q,$location) {

            var loadingCount = 0;

            var reqResInterceptor = {
                request: function (config) {
                    config.headers = config.headers || {};
                    config.headers['token-Id'] = ApplicationService.getTokenId();
                    config.headers['tab-id'] = ApplicationService.getSelectedTab();

                    if (!config.headers['ignore-me']) {
                        ApplicationService.setLastServiceCallTime();
                    }

                    if (!!config.headers['show-loading']) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                        loadingCount++;
                    }

                    return config;
                },
                response: function (response) {
                    if (response.config && response.config.headers['show-loading']) {
                        if (--loadingCount <= 0) {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                        }
                    }
                    return response;
                },
                responseError: function (response) {

                    if(!!response.data && !!response.data.sessionTimeOut && !$location.search().ref && !!response.config.headers['token-Id']){
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_LOGGED_OUT);
                    }

                    if (--loadingCount <= 0) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }
                    return $q.reject(response);
                }
            };
            return reqResInterceptor;
        }]);
})();
